import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

class CryptoOptions extends Component {
  state = {
    loadingAmount: null,
    error: '',
  };

  handleSelectAmount = async (baseAmount) => {
    try {
      this.setState({
        loadingAmount: baseAmount,
        error: '',
      });

      const res = await fetch('/api/crypto/create-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          baseAmount,
          creditsToClaim: 100,
          userEmail: this.props.userEmail || null,
          payerAddress: this.props.payerAddress || null,
        }),
      });

      const data = await res.json();
      console.log('create-order response:', data);

      if (!res.ok || !data.ok) {
        throw new Error(data.message || 'Failed to create payment order');
      }

      this.props.history.push('/cryptopay', {
        orderId: data.orderId,
        baseAmount: data.baseAmount,
        exactAmount: data.exactAmount,
        suffixAmount: data.suffixAmount,
        merchantWallet: data.merchantWallet,
        tokenContract: data.tokenContract,
        expiresAt: data.expiresAt,
        creditsToClaim: data.creditsToClaim || 100,
      });
    } catch (err) {
      console.error('Create order error:', err);
      this.setState({
        error: err.message || 'Something went wrong',
        loadingAmount: null,
      });
      return;
    }

    this.setState({
      loadingAmount: null,
    });
  };

  renderPayButton = (amount) => {
    const isLoading = this.state.loadingAmount === amount;

    return (
      <div style={{ marginBottom: '12px' }}>
        <button
          onClick={() => this.handleSelectAmount(amount)}
          disabled={this.state.loadingAmount !== null}
          style={{
            padding: '12px 20px',
            fontSize: '16px',
            minWidth: '220px',
            borderRadius: '8px',
            border: 'none',
            background: '#111',
            color: '#fff',
            cursor: this.state.loadingAmount !== null ? 'not-allowed' : 'pointer',
          }}
        >
          {isLoading ? `Creating ${amount} USDT order...` : `Pay ${amount} USDT`}
        </button>
      </div>
    );
  };

  render() {
    const { error } = this.state;

    return (
      <div className='RewardsOptions' style={{ textAlign: 'center', padding: '20px' }}>
        <img className='logo' src={logo} alt="Logo" />
        <br />
        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
          How Much Do You Want to Fill to Your Wallet...
        </div>
        <br />

        {this.renderPayButton(10)}
        {this.renderPayButton(20)}
        {this.renderPayButton(50)}
        {this.renderPayButton(100)}

        {error && (
          <>
            <br />
            <div style={{ color: 'red', fontWeight: 'bold' }}>{error}</div>
          </>
        )}

        <br />
        <div>
          For more than 100 coins please contact the admin at admin1@newwaveconsultantsbkk.com
        </div>
        <br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="Logo 2" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default withRouter(CryptoOptions);
